import { useRef, useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import {
  LanguageToggleIcon,
  langaugesItems,
  LanguageIcon,
  languageIconMap,
} from './LanguageSelector';
import { MHMIconButton } from '../MHM/MHMIconButton';

export function DesktopLanguageSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const anchor = useRef<HTMLButtonElement | null>(null);

  const { top, left } = anchor.current?.getBoundingClientRect() || {
    top: 0,
    left: 0,
  };

  function openLanguageMenu(_: React.MouseEvent<HTMLButtonElement>) {
    setIsOpen(prev => !prev);
  }

  function closeLanguageMenu() {
    setIsOpen(false);
  }

  return (
    <>
      <MHMIconButton
        ref={anchor}
        aria-controls={isOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        aria-label="select language"
        onClick={openLanguageMenu}
        sx={{ p: 0, position: 'relative' }}
        color="highlight"
        disableRipple
        disableFocusRipple
        disableTouchRipple
      >
        <LanguageToggleIcon />
      </MHMIconButton>
      <Menu
        anchorReference="anchorPosition"
        anchorPosition={{ top: top + 45, left }}
        open={isOpen}
        onClose={closeLanguageMenu}
        slotProps={{
          paper: {
            style: {
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none',
            },
          },
          list: {
            sx: {
              py: 0.75,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            },
          },
        }}
      >
        {langaugesItems.map(lang => (
          <MenuItem
            key={lang.code}
            sx={{ p: 0, backgroundColor: 'transparent !important' }}
            disableRipple
            disableTouchRipple
            onClick={closeLanguageMenu}
          >
            <LanguageIcon
              language={lang.code}
              imgSrc={languageIconMap[lang.code]}
              languageName={lang.name}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
